<template>
  <div v-if="store.active" class="tg-decor" aria-hidden="true" data-testid="thanksgiving-decor">
    <div v-if="store.isEggEnabled('warmGlow')" class="tg-glow" data-testid="thanksgiving-glow" />

    <template v-if="store.isEggEnabled('leaves')">
      <span v-for="leaf in leaves" :key="leaf.id" class="tg-leaf" :style="leaf.style" data-testid="thanksgiving-leaf">
        <span class="tg-leaf__sway">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path :d="leaf.shape" :fill="leaf.colour" />
          </svg>
        </span>
      </span>
    </template>

    <div v-if="store.isEggEnabled('wreath')" class="tg-wreath" data-testid="thanksgiving-wreath">
      <svg viewBox="0 0 160 170" xmlns="http://www.w3.org/2000/svg">
        <circle cx="80" cy="76" r="46" fill="none" stroke="#78350f" stroke-width="7" />
        <g class="tg-wreath__ring">
          <path
            d="M12 2c1.6 1.4 1 3 2.6 3.4 1.8.4 2.8-1 3.6.6.8 1.6-1.2 2.4-.4 3.8.8 1.4 2.8 1 2.6 2.8-.2 1.8-2.6 1.2-3 2.6-.4 1.6 1.4 2.6.2 3.8-1.2 1.2-2.6-.6-3.8.2-1 .7-.6 2.4-1.2 3.6h-1.2c-.6-1.2-.2-2.9-1.2-3.6-1.2-.8-2.6 1-3.8-.2-1.2-1.2.6-2.2.2-3.8-.4-1.4-2.8-.8-3-2.6-.2-1.8 1.8-1.4 2.6-2.8.8-1.4-1.2-2.2-.4-3.8.8-1.6 1.8-.2 3.6-.6C11 5 10.4 3.4 12 2z"
            fill="#b91c1c"
            transform="translate(122.5 74.7) rotate(58.3) scale(1.2) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#ea580c"
            transform="translate(122.8 88.8) rotate(107.2) scale(1) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#f59e0b"
            transform="translate(120 97.4) rotate(89.5) scale(1) translate(-12 -12)"
          />
          <path
            d="M12 2c1.6 1.4 1 3 2.6 3.4 1.8.4 2.8-1 3.6.6.8 1.6-1.2 2.4-.4 3.8.8 1.4 2.8 1 2.6 2.8-.2 1.8-2.6 1.2-3 2.6-.4 1.6 1.4 2.6.2 3.8-1.2 1.2-2.6-.6-3.8.2-1 .7-.6 2.4-1.2 3.6h-1.2c-.6-1.2-.2-2.9-1.2-3.6-1.2-.8-2.6 1-3.8-.2-1.2-1.2.6-2.2.2-3.8-.4-1.4-2.8-.8-3-2.6-.2-1.8 1.8-1.4 2.6-2.8.8-1.4-1.2-2.2-.4-3.8.8-1.6 1.8-.2 3.6-.6C11 5 10.4 3.4 12 2z"
            fill="#a16207"
            transform="translate(112.8 112.8) rotate(119) scale(1) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#c2410c"
            transform="translate(99.9 122.4) rotate(149.5) scale(1.2) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#d97706"
            transform="translate(82.5 117.4) rotate(161.9) scale(1.3) translate(-12 -12)"
          />
          <path
            d="M12 2c1.6 1.4 1 3 2.6 3.4 1.8.4 2.8-1 3.6.6.8 1.6-1.2 2.4-.4 3.8.8 1.4 2.8 1 2.6 2.8-.2 1.8-2.6 1.2-3 2.6-.4 1.6 1.4 2.6.2 3.8-1.2 1.2-2.6-.6-3.8.2-1 .7-.6 2.4-1.2 3.6h-1.2c-.6-1.2-.2-2.9-1.2-3.6-1.2-.8-2.6 1-3.8-.2-1.2-1.2.6-2.2.2-3.8-.4-1.4-2.8-.8-3-2.6-.2-1.8 1.8-1.4 2.6-2.8.8-1.4-1.2-2.2-.4-3.8.8-1.6 1.8-.2 3.6-.6C11 5 10.4 3.4 12 2z"
            fill="#dc2626"
            transform="translate(76.6 118) rotate(206.8) scale(1.1) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#92400e"
            transform="translate(63 119.6) rotate(192.4) scale(1.2) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#b91c1c"
            transform="translate(52.5 107.2) rotate(200.8) scale(1) translate(-12 -12)"
          />
          <path
            d="M12 2c1.6 1.4 1 3 2.6 3.4 1.8.4 2.8-1 3.6.6.8 1.6-1.2 2.4-.4 3.8.8 1.4 2.8 1 2.6 2.8-.2 1.8-2.6 1.2-3 2.6-.4 1.6 1.4 2.6.2 3.8-1.2 1.2-2.6-.6-3.8.2-1 .7-.6 2.4-1.2 3.6h-1.2c-.6-1.2-.2-2.9-1.2-3.6-1.2-.8-2.6 1-3.8-.2-1.2-1.2.6-2.2.2-3.8-.4-1.4-2.8-.8-3-2.6-.2-1.8 1.8-1.4 2.6-2.8.8-1.4-1.2-2.2-.4-3.8.8-1.6 1.8-.2 3.6-.6C11 5 10.4 3.4 12 2z"
            fill="#ea580c"
            transform="translate(41.2 99.3) rotate(245.1) scale(1.1) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#f59e0b"
            transform="translate(37.9 88.7) rotate(267.1) scale(1.3) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#a16207"
            transform="translate(33.3 78.1) rotate(293.7) scale(1.2) translate(-12 -12)"
          />
          <path
            d="M12 2c1.6 1.4 1 3 2.6 3.4 1.8.4 2.8-1 3.6.6.8 1.6-1.2 2.4-.4 3.8.8 1.4 2.8 1 2.6 2.8-.2 1.8-2.6 1.2-3 2.6-.4 1.6 1.4 2.6.2 3.8-1.2 1.2-2.6-.6-3.8.2-1 .7-.6 2.4-1.2 3.6h-1.2c-.6-1.2-.2-2.9-1.2-3.6-1.2-.8-2.6 1-3.8-.2-1.2-1.2.6-2.2.2-3.8-.4-1.4-2.8-.8-3-2.6-.2-1.8 1.8-1.4 2.6-2.8.8-1.4-1.2-2.2-.4-3.8.8-1.6 1.8-.2 3.6-.6C11 5 10.4 3.4 12 2z"
            fill="#c2410c"
            transform="translate(38.4 62) rotate(261.9) scale(1.3) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#d97706"
            transform="translate(38.8 50.3) rotate(301.1) scale(1) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#dc2626"
            transform="translate(46 42.6) rotate(319.6) scale(1.3) translate(-12 -12)"
          />
          <path
            d="M12 2c1.6 1.4 1 3 2.6 3.4 1.8.4 2.8-1 3.6.6.8 1.6-1.2 2.4-.4 3.8.8 1.4 2.8 1 2.6 2.8-.2 1.8-2.6 1.2-3 2.6-.4 1.6 1.4 2.6.2 3.8-1.2 1.2-2.6-.6-3.8.2-1 .7-.6 2.4-1.2 3.6h-1.2c-.6-1.2-.2-2.9-1.2-3.6-1.2-.8-2.6 1-3.8-.2-1.2-1.2.6-2.2.2-3.8-.4-1.4-2.8-.8-3-2.6-.2-1.8 1.8-1.4 2.6-2.8.8-1.4-1.2-2.2-.4-3.8.8-1.6 1.8-.2 3.6-.6C11 5 10.4 3.4 12 2z"
            fill="#92400e"
            transform="translate(64.3 34.7) rotate(345.8) scale(1.2) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#b91c1c"
            transform="translate(74.1 30.8) rotate(383.7) scale(1.3) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#ea580c"
            transform="translate(86.6 28.8) rotate(382) scale(1) translate(-12 -12)"
          />
          <path
            d="M12 2c1.6 1.4 1 3 2.6 3.4 1.8.4 2.8-1 3.6.6.8 1.6-1.2 2.4-.4 3.8.8 1.4 2.8 1 2.6 2.8-.2 1.8-2.6 1.2-3 2.6-.4 1.6 1.4 2.6.2 3.8-1.2 1.2-2.6-.6-3.8.2-1 .7-.6 2.4-1.2 3.6h-1.2c-.6-1.2-.2-2.9-1.2-3.6-1.2-.8-2.6 1-3.8-.2-1.2-1.2.6-2.2.2-3.8-.4-1.4-2.8-.8-3-2.6-.2-1.8 1.8-1.4 2.6-2.8.8-1.4-1.2-2.2-.4-3.8.8-1.6 1.8-.2 3.6-.6C11 5 10.4 3.4 12 2z"
            fill="#f59e0b"
            transform="translate(102.3 30.2) rotate(370.9) scale(1.3) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#a16207"
            transform="translate(110.5 39.3) rotate(397.1) scale(1) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#c2410c"
            transform="translate(114.1 51.2) rotate(432.7) scale(1) translate(-12 -12)"
          />
          <path
            d="M12 2c1.6 1.4 1 3 2.6 3.4 1.8.4 2.8-1 3.6.6.8 1.6-1.2 2.4-.4 3.8.8 1.4 2.8 1 2.6 2.8-.2 1.8-2.6 1.2-3 2.6-.4 1.6 1.4 2.6.2 3.8-1.2 1.2-2.6-.6-3.8.2-1 .7-.6 2.4-1.2 3.6h-1.2c-.6-1.2-.2-2.9-1.2-3.6-1.2-.8-2.6 1-3.8-.2-1.2-1.2.6-2.2.2-3.8-.4-1.4-2.8-.8-3-2.6-.2-1.8 1.8-1.4 2.6-2.8.8-1.4-1.2-2.2-.4-3.8.8-1.6 1.8-.2 3.6-.6C11 5 10.4 3.4 12 2z"
            fill="#d97706"
            transform="translate(120.8 61.1) rotate(455.9) scale(1.1) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#a16207"
            opacity="0.9"
            transform="translate(110.9 84.3) rotate(105) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#c2410c"
            opacity="0.9"
            transform="translate(102.6 98.6) rotate(135) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#d97706"
            opacity="0.9"
            transform="translate(88.3 106.9) rotate(165) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#dc2626"
            opacity="0.9"
            transform="translate(71.7 106.9) rotate(195) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#92400e"
            opacity="0.9"
            transform="translate(57.4 98.6) rotate(225) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#b91c1c"
            opacity="0.9"
            transform="translate(49.1 84.3) rotate(255) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#ea580c"
            opacity="0.9"
            transform="translate(49.1 67.7) rotate(285) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#f59e0b"
            opacity="0.9"
            transform="translate(57.4 53.4) rotate(315) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#a16207"
            opacity="0.9"
            transform="translate(71.7 45.1) rotate(345) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#c2410c"
            opacity="0.9"
            transform="translate(88.3 45.1) rotate(375) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#d97706"
            opacity="0.9"
            transform="translate(102.6 53.4) rotate(405) scale(0.8) translate(-12 -12)"
          />
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#dc2626"
            opacity="0.9"
            transform="translate(110.9 67.7) rotate(435) scale(0.8) translate(-12 -12)"
          />
          <g transform="translate(40.5 61.6)">
            <ellipse cx="0" cy="3" rx="4.2" ry="5.2" fill="#a16207" />
            <path d="M-5 0c0-3 2.2-4.4 5-4.4S5-3 5 0z" fill="#5c3418" />
            <path d="M0-4.4v-2.4" stroke="#5c3418" stroke-width="1.4" stroke-linecap="round" />
          </g>
          <g transform="translate(65.6 36.5)">
            <ellipse cx="0" cy="3" rx="4.2" ry="5.2" fill="#a16207" />
            <path d="M-5 0c0-3 2.2-4.4 5-4.4S5-3 5 0z" fill="#5c3418" />
            <path d="M0-4.4v-2.4" stroke="#5c3418" stroke-width="1.4" stroke-linecap="round" />
          </g>
          <g transform="translate(112.2 49)">
            <ellipse cx="0" cy="3" rx="4.2" ry="5.2" fill="#a16207" />
            <path d="M-5 0c0-3 2.2-4.4 5-4.4S5-3 5 0z" fill="#5c3418" />
            <path d="M0-4.4v-2.4" stroke="#5c3418" stroke-width="1.4" stroke-linecap="round" />
          </g>
          <g transform="translate(119.5 90.4)">
            <ellipse cx="0" cy="3" rx="4.2" ry="5.2" fill="#a16207" />
            <path d="M-5 0c0-3 2.2-4.4 5-4.4S5-3 5 0z" fill="#5c3418" />
            <path d="M0-4.4v-2.4" stroke="#5c3418" stroke-width="1.4" stroke-linecap="round" />
          </g>
        </g>
        <g class="tg-wreath__wheat">
          <g transform="translate(66 132) rotate(-28)">
            <path d="M0 0V-34" stroke="#ca8a04" stroke-width="1.6" stroke-linecap="round" />
            <ellipse cx="2.2" cy="-10.0" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -10.0)" />
            <ellipse cx="-2.2" cy="-14.2" rx="2" ry="3.6" fill="#facc15" transform="rotate(-20 -2.2 -14.2)" />
            <ellipse cx="2.2" cy="-18.4" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -18.4)" />
            <ellipse cx="-2.2" cy="-22.6" rx="2" ry="3.6" fill="#facc15" transform="rotate(-20 -2.2 -22.6)" />
            <ellipse cx="2.2" cy="-26.8" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -26.8)" />
          </g>
          <g transform="translate(75 132) rotate(-12)">
            <path d="M0 0V-34" stroke="#ca8a04" stroke-width="1.6" stroke-linecap="round" />
            <ellipse cx="2.2" cy="-10.0" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -10.0)" />
            <ellipse cx="-2.2" cy="-14.2" rx="2" ry="3.6" fill="#facc15" transform="rotate(-20 -2.2 -14.2)" />
            <ellipse cx="2.2" cy="-18.4" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -18.4)" />
            <ellipse cx="-2.2" cy="-22.6" rx="2" ry="3.6" fill="#facc15" transform="rotate(-20 -2.2 -22.6)" />
            <ellipse cx="2.2" cy="-26.8" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -26.8)" />
          </g>
          <g transform="translate(85 132) rotate(12)">
            <path d="M0 0V-34" stroke="#ca8a04" stroke-width="1.6" stroke-linecap="round" />
            <ellipse cx="2.2" cy="-10.0" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -10.0)" />
            <ellipse cx="-2.2" cy="-14.2" rx="2" ry="3.6" fill="#facc15" transform="rotate(-20 -2.2 -14.2)" />
            <ellipse cx="2.2" cy="-18.4" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -18.4)" />
            <ellipse cx="-2.2" cy="-22.6" rx="2" ry="3.6" fill="#facc15" transform="rotate(-20 -2.2 -22.6)" />
            <ellipse cx="2.2" cy="-26.8" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -26.8)" />
          </g>
          <g transform="translate(94 132) rotate(28)">
            <path d="M0 0V-34" stroke="#ca8a04" stroke-width="1.6" stroke-linecap="round" />
            <ellipse cx="2.2" cy="-10.0" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -10.0)" />
            <ellipse cx="-2.2" cy="-14.2" rx="2" ry="3.6" fill="#facc15" transform="rotate(-20 -2.2 -14.2)" />
            <ellipse cx="2.2" cy="-18.4" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -18.4)" />
            <ellipse cx="-2.2" cy="-22.6" rx="2" ry="3.6" fill="#facc15" transform="rotate(-20 -2.2 -22.6)" />
            <ellipse cx="2.2" cy="-26.8" rx="2" ry="3.6" fill="#facc15" transform="rotate(20 2.2 -26.8)" />
          </g>
        </g>
        <path d="M60 122c-10 4-16 12-16 20l12-6 6 10c4-8 4-16-2-24z" fill="#9a3412" />
        <path d="M100 122c10 4 16 12 16 20l-12-6-6 10c-4-8-4-16 2-24z" fill="#9a3412" />
        <path d="M28 128h104l-8 10 8 10H28l8-10z" fill="#ea580c" />
        <path d="M28 128h104l-2 2.4H30z" fill="#fdba74" opacity="0.7" />
        <circle cx="80" cy="124" r="7" fill="#c2410c" />
        <text x="80" y="143" text-anchor="middle" font-size="15" fill="#fffbeb" font-family="Pacifico, Faktum, cursive">
          Give thanks
        </text>
      </svg>
      <span class="tg-wreath__leaf">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z"
            fill="#ea580c"
          />
        </svg>
      </span>
    </div>

    <ThanksgivingFeast v-if="feasting" />
  </div>
</template>

<script setup lang="ts">
import { useThanksgivingThemeStore } from '~/store/thanksgiving-theme';
import { useToastStore } from '~/store/toast';

import ThanksgivingFeast from './ThanksgivingFeast.vue';

const GOBBLE = 'gobble';
const TYPING_TAGS = ['INPUT', 'SELECT', 'TEXTAREA'];
const FONT_URL = 'https://fonts.googleapis.com/css2?family=Pacifico&display=swap';

const FEAST_MS = 8500;
const TOAST_MS = 5000;

const LEAF_SHAPES = [
  'M12 1.5l1.6 3.4 2.4-1-.6 4.6 3.4-2.3.2 2.5 3-.5-1.6 3.6 1.6 1.2-5.4 3.8.6 1.9-4.6-.7v4.5h-1.2V18l-4.6.7.6-1.9L2 13l1.6-1.2L2 8.2l3 .5.2-2.5 3.4 2.3L8 3.9l2.4 1z',
  'M12 2c4 3 7 7 7 11a7 7 0 0 1-6.4 7v2.5h-1.2V20A7 7 0 0 1 5 13c0-4 3-8 7-11z',
  'M12 2c2 2 3 3 3 5 1.5-1 3.5-1 5 0-1 2-2 3-4 3.5 1.5 1 2.5 3 2 5-2 0-3.5-.5-4.4-1.6V22h-1.2v-8.1C11.5 15 10 15.5 8 15.5c-.5-2 .5-4 2-5-2-.5-3-1.5-4-3.5 1.5-1 3.5-1 5 0 0-2 1-3 1-5z',
];
const LEAF_COLOURS = ['#b91c1c', '#ea580c', '#f59e0b', '#a16207', '#c2410c', '#d97706'];
const LEAF_COUNT = 10;

const store = useThanksgivingThemeStore();
const toastStore = useToastStore();

const feasting = ref(false);
const timers = new Set<ReturnType<typeof setTimeout>>();
let typed = '';
let appliedClasses: string[] = [];

function later(fn: () => void, ms: number) {
  const timer = setTimeout(() => {
    timers.delete(timer);
    fn();
  }, ms);

  timers.add(timer);
}

function between([min, max]: readonly [number, number]): number {
  return min + Math.random() * (max - min);
}

const leaves = Array.from({ length: LEAF_COUNT }, (_, id) => ({
  colour: LEAF_COLOURS[id % LEAF_COLOURS.length],
  id,
  shape: LEAF_SHAPES[id % LEAF_SHAPES.length],
  style: {
    '--tg-leaf-delay': `${-Math.round(Math.random() * 24)}s`,
    '--tg-leaf-drift': `${Math.round(between([-14, 14]))}vw`,
    '--tg-leaf-fall': `${Math.round(between([16, 28]))}s`,
    '--tg-leaf-size': `${Math.round(between([16, 30]))}px`,
    '--tg-leaf-sway': `${between([2.4, 4.2]).toFixed(1)}s`,
    left: `${Math.round(between([2, 96]))}vw`,
  },
}));

function feast() {
  if (feasting.value) return;

  feasting.value = true;
  toastStore.addToast({
    message: 'Gobble gobble! Thanks for being part of the Order Protection family.',
    timeout: TOAST_MS,
    title: 'Happy Thanksgiving!',
    type: 'success',
  });
  later(() => {
    feasting.value = false;
  }, FEAST_MS);
}

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;

  return target.isContentEditable || TYPING_TAGS.includes(target.tagName);
}

function onKeydown(event: KeyboardEvent) {
  if (!store.isEggEnabled('gobble') || event.key.length !== 1 || isTypingTarget(event.target)) return;

  typed = (typed + event.key.toLowerCase()).slice(-GOBBLE.length);
  if (typed !== GOBBLE) return;

  typed = '';
  feast();
}

function applyRootClasses(classes: string[]) {
  const root = document.documentElement;

  root.classList.remove(...appliedClasses);
  root.classList.add(...classes);
  appliedClasses = classes;
}

// The script face is fetched only while the theme is showing.
useHead({
  link: computed(() => (store.active ? [{ href: FONT_URL, rel: 'stylesheet' }] : [])),
});

onMounted(() => {
  store.sync();
  watch(() => store.htmlClasses, applyRootClasses, { immediate: true });
  window.addEventListener('keydown', onKeydown);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown);
  timers.forEach(clearTimeout);
  timers.clear();
  applyRootClasses([]);
});
</script>
